import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import WOW from 'wow.js';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to the top of the page
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });

    // Initialize WOW.js
    const wow = new WOW({
      live: false, // Prevent WOW.js from automatically observing DOM mutations
    });
    wow.init();

    // Explicitly sync WOW.js to detect new content
    wow.sync();

  }, [pathname]);

  return null;
};

export default ScrollToTop;
